import * as React from 'react';

import { type TModifier } from '@/packages/Filters';
import { type NonEmptyArray } from '@/packages/JsonQuery';

import { useReduxDispatch } from '@/microfrontends/filters/shared/store';
import { geoTagsActions } from '@/microfrontends/filters/shared/store/slices/geoTags';
import { updateLocation } from '@/microfrontends/filters/shared/store/thunks/location/updateLocation';
import { tempNormalizeLocation } from '@/microfrontends/filters/shared/utils/tempNormalizeLocation';
type TSetHighwaysFunction = (highway: {
  id: number;
  regionId?: number;
  name: string;
}) => Promise<NonEmptyArray<TModifier>>;

export function useSetHighways(): TSetHighwaysFunction {
  const dispatch = useReduxDispatch();

  return React.useCallback<TSetHighwaysFunction>(
    async highway => {
      const modifiers: NonEmptyArray<TModifier> = [
        {
          action: 'setHighways',
          arguments: [
            {
              type: 'highway',
              id: highway.id,
            },
          ],
        },
      ];

      dispatch(
        geoTagsActions.add([
          {
            type: 'highway',
            id: highway.id,
            name: highway.name,
          },
        ]),
      );

      // переключаем регион в фильтрах на тот который пришел из саджеста
      if (highway.regionId) {
        const updateLocationResult = await dispatch(updateLocation({ regionId: highway.regionId }));

        if (updateLocation.fulfilled.match(updateLocationResult)) {
          const prevLocation = tempNormalizeLocation(updateLocationResult.payload.prev);
          const nextLocation = tempNormalizeLocation(updateLocationResult.payload.next);

          /**
           * сначала меняем локацию
           * тк при смене гео с МСК на МО все гео фильтры будут сброшены
           */
          modifiers.unshift({ action: 'setLocations', arguments: [{ prev: prevLocation, next: nextLocation }] });
        }
      }

      return modifiers;
    },
    [dispatch],
  );
}
